<template>
  <div class="menu">
    <router-link to="/">
      <div class="logo" />
    </router-link>
    <el-dropdown trigger="click" class="el-menu">
      <span class="el-dropdown-link">
        <el-avatar class="img-user" icon="el-icon-user-solid" :src="info.avatar" />
        {{ info.name }}
        <i class="el-icon-arrow-down el-icon--right" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <router-link to="/">
          <el-dropdown-item>首页</el-dropdown-item>
        </router-link>
        <router-link to="/user/detail">
          <el-dropdown-item>个人信息</el-dropdown-item>
        </router-link>
        <el-dropdown-item @click.native="handleLogout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { removeToken } from '@/utils/token'
import { logout } from '@/api/common'

export default {
  name: 'Header',
  data() {
    return {
      info: null
    }
  },
  beforeMount() {
    this.info = JSON.parse(sessionStorage.getItem('info'))
  },
  methods: {
    handleLogout() {
      logout().then((response) => {
        removeToken()
        sessionStorage.clear()
        // 刷新到登录页，同时重置 Vue Router 3 已动态注入的当前账号权限路由。
        window.location.href = '/login'
      })
    }
  }
}
</script>

<style scoped>
  .menu {
    height: 60px;
    width: 100%;
    position: fixed;
    z-index: 999;
    top: 0;
  }
  .logo {
    width: 50px;
    height: 50px;
    background: url("../../assets/logo2.png");
    background-size: cover;
    position: absolute;
    left: 15px;
    top: 4px;
    cursor: pointer;
  }
  .el-menu {
    height: 60px;
    position: absolute;
    top: 0;
    right: 10px;
    background-color: rgba(153,153,153,0);
    border: none;
    cursor: pointer;
  }
  .img-user {
    float: left;
    margin-top: 10px;
  }
  .el-dropdown-link {
    height: 60px;
    line-height: 60px;
    color: #fff;
    padding-left: 12px;
    outline: none
  }
</style>
